import {
  InfrastructureResponseBuilder,
  type InfrastructureResponse,
} from '@teachino/shared-infrastructure';
import { useQuery } from '@urql/vue';
import { computed, ref } from 'vue';
import {
  convertTopicListItemFragment,
  type TopicListItem,
} from '../folders/topic-list-item';
import type { MaterialListItem } from '../materials/material-list-item.fragment';
import { librarySearchQuery } from './library-search.query';
import type { SearchFacade } from './search.facade';

export class SearchService implements SearchFacade {
  private _currentSearchTerm = ref<string | null>(null);
  private readonly MIN_SEARCH_TERM_LENGTH = 3;
  currentSearchTerm = computed(() => this._currentSearchTerm.value);

  isSearchActive = computed(
    () =>
      this._currentSearchTerm.value !== null &&
      this._currentSearchTerm.value.length >= this.MIN_SEARCH_TERM_LENGTH,
  );

  private searchQuery = useQuery({
    query: librarySearchQuery,
    variables: computed(() => {
      return {
        search: this._currentSearchTerm.value,
      };
    }),
    pause: computed(() => !this.isSearchActive.value),
  });

  searchResults(): InfrastructureResponse<{
    topics: TopicListItem[];
    materials: MaterialListItem[];
  }> {
    return InfrastructureResponseBuilder.fromQuery(this.searchQuery)
      .withMapper((result) => {
        const topics = result.topics
          .filter((searchContent) => searchContent.__typename === 'Folder')
          .map((searchContent) => {
            return convertTopicListItemFragment(searchContent);
          });
        const materials = result.materials
          .filter((searchContent) => searchContent.__typename === 'Material')
          .map((searchContent) => {
            return searchContent;
          });
        return { topics, materials };
      })
      .build();
  }

  search(term: string): void {
    this._currentSearchTerm.value = term;
  }

  resetSearch(): void {
    this._currentSearchTerm.value = null;
  }
}
